import {observable, computed, action} from "mobx";
import {find, findIndex, merge, sortBy} from 'lodash';

import {event} from '../utilities/withAnalytics';
import {storageAvailable} from '../utilities/localstorageHelpers';

export default class SidebarStore {
  constructor(rootStore){
    this._rootStore = rootStore;
    this.personaList = this.loadFromLocalStorage();
  }
  @observable personaList = [];
  @observable showIndicators = true;

  @action
  toggleIndicators = (overrideState) => {
    const indicatorVis = overrideState ? overrideState : !this.showIndicators;
    event('Indicators','Toggle', indicatorVis ? 'Off' : 'On');
    this.showIndicators = indicatorVis;
  }

  @action.bound
  updatePersonaList() {
    const persona = this.listItem;
    // Get our stored array of persona meta data
    const existingItem = find(this.personaList, {id: persona.id});
    if (existingItem) {
      // We have an existing id for this item
      if (existingItem.key) {
        // We don't want to lose existing item key
        persona.key = existingItem.key;
      }
      const index = findIndex(this.personaList, {id: persona.id});
      this.personaList[index] = persona;
    } else {
      // We don't have an existing id for this item
      this.personaList.push(persona);
    }
    this.personaList = sortBy(this.personaList, 'updated_at').reverse();
    this.setToLocalStorage();
  };

  loadFromLocalStorage = () => {
    let personaList = [];
    if (storageAvailable('localStorage')) {
      try {
        personaList = JSON.parse(localStorage.getItem('personaList')) || [];
      } catch (err) {
        this._rootStore.alertStore.addError(err);
      }
    }
    return personaList;
  }

  @action.bound
  setToLocalStorage() {
    if (storageAvailable('localStorage')) {
      try {
        const stringifiedList = JSON.stringify(this.personaList);
        localStorage.setItem('personaList', stringifiedList);
      } catch (err) {
        this._rootStore.alertStore.addError(err);
      }
    }
  }

  @computed
  get listItem() {
    const {personaStore, templateStore} = this._rootStore;
    const {id, key, updated_at, body} = personaStore;
    const {
      age,
      education,
      marital_status,
      name,
      occupation,
      persona_image,
      residence,
      template_id,
      theme,
    } = body;
    const templateId = template_id || templateStore.template_id;
    const template = templateStore.getTemplate(templateId);
    return merge({}, template, {
      age,
      education,
      id,
      key,
      marital_status,
      name,
      occupation,
      persona_image,
      residence,
      template_id: templateId,
      theme,
      updated_at,
    });
  }

  async addEmail(email) {
    const {id, key} = this._rootStore.personaStore;
    try {
      const response = await fetch(
        '/api/email',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email,
            id,
            key,
          })
        }
      );
      if (response.status !== 200) {
        this._rootStore.alertStore.addError(response.error);
      } else {
        // const json = result.json();
        this._rootStore.alertStore.addEmailAlert(email);
      }
    } catch (e) {
      this._rootStore.alertStore.addError(e);
    }

  }

}



// WEBPACK FOOTER //
// ./client/modules/SidebarStore.js